import { render, staticRenderFns } from "./AdministrativeProcurementInconformity.vue?vue&type=template&id=2dba8681&scoped=true"
import script from "./AdministrativeProcurementInconformity.vue?vue&type=script&lang=js"
export * from "./AdministrativeProcurementInconformity.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeProcurementInconformity.vue?vue&type=style&index=0&id=2dba8681&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba8681",
  null
  
)

export default component.exports